import { HttpErrorResponse } from '@angular/common/http';
import { TechAdminStore } from './tech-admin.store';
import { MatTabsModule, MatTabChangeEvent } from '@angular/material/tabs';
import { Component, OnInit } from '@angular/core';
import { Alert, DatosToggle, SemaphoreColor, Job, JobResponse } from './tech-admin.models';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map } from 'rxjs/operators';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-tech-admin',
  templateUrl: './tech-admin.component.html',
  styleUrls: ['./tech-admin.component.scss'],
})
export class TechAdminComponent implements OnInit {
  constructor(
    private techAdminStore: TechAdminStore,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) {}

  displayedColumns: string[] = [
    'statusSemaphore',
    'firstTimeCrashReported',
    'numTimes',
    'name',
    'maxAllowed',
    'secondsPeriodAllowed',
    'ruleType',
    'active',
  ];

  displayedColumnsJobs: string[] = ['jobName', 'active'];

  dataSourceAuth: Alert[] = [];
  dataSourceSignature: Alert[] = [];
  dataSourceRequest: Alert[] = [];
  dataSourceAdmin: Alert[] = [];
  dataJob: Job[] = [];

  timerSubscription: Subscription;

  ngOnInit(): void {
    //reload page in 2 min
    // timer(0, 120000) call the function immediately and every 2 min
    this.timerSubscription = timer(0, 120000)
      .pipe(
        map(() => {
          this.updateTables(); // load data contains the http request
        })
      )
      .subscribe();

    //Necesitan updatear todos para obtener los valores de todos los arrays de las tablas
    this.updateAuthDashboard();
    this.updateSignatureDashboard();
    this.updateRequestDashboard();
    this.updateAdminDashboard();

    //Jobs
    this.updateJobDashboard();
  }

  updateTables() {
    this.updateAuthDashboard();
    this.updateSignatureDashboard();
    this.updateRequestDashboard();
    this.updateAdminDashboard();

    //Jobs
    this.updateJobDashboard();
  }

  loadgraphic: boolean = false;

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross', noRedirect: true };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  //metodos dashboard para reutilizar
  updateAuthDashboard() {
    this.techAdminStore.getAuthenticationDashboard().subscribe(
      (resp) => {
        this.dataSourceAuth = resp.alerts;
        this.sortData(this.dataSourceAuth);
        this.removeElement(this.dataSourceAuth, 'LOGALTY_CONNECTION');
      },
      (error) => {
        this.showDialogError(this.translateService.instant('error.pagina_403'));
        this.loadgraphic = false;
      }
    );
  }
  updateSignatureDashboard() {
    this.techAdminStore.getSignatureDashboard().subscribe(
      (resp) => {
        this.dataSourceSignature = resp.alerts;
        this.sortData(this.dataSourceSignature); //Necesita ordenar por defecto
      },
      (error) => {
        this.showDialogError(this.translateService.instant('error.pagina_403'));
        this.loadgraphic = false;
      }
    );
  }
  updateRequestDashboard() {
    this.techAdminStore.getRequestDashboard().subscribe(
      (resp) => {
        this.dataSourceRequest = resp.alerts;
        this.sortData(this.dataSourceRequest);
        this.removeElement(this.dataSourceRequest, 'LOGALTY_CONNECTION');
      },
      (error) => {
        this.showDialogError(this.translateService.instant('error.pagina_403'));
        this.loadgraphic = false;
      }
    );
  }
  updateAdminDashboard() {
    this.techAdminStore.getAdministrationDashboard().subscribe(
      (resp) => {
        this.dataSourceAdmin = resp.alerts;
        this.sortData(this.dataSourceAdmin);
        this.removeElement(this.dataSourceAdmin, 'LOGALTY_CONNECTION');
      },
      (error) => {
        this.showDialogError(this.translateService.instant('error.pagina_403'));
        this.loadgraphic = false;
      }
    );
  }

  //Actualiza tabla jobs
  updateJobDashboard() {
    this.techAdminStore.getJobsDashboard().subscribe((resp) => {
      this.dataJob = [];
      for (let i = 0; i < Object.keys(resp).length; i++) {
        this.dataJob.push(resp[i]);
      }
      this.sortDataJobs(this.dataJob);
    });
  }

  //tabName: string = 'Authentication';

  //cuando el usuario cambia de Tab
  onChangeTab($event: MatTabChangeEvent) {
    let tabSeleccionado: string = $event.tab.textLabel;
    //this.tabName = tabSeleccionado;
    if (tabSeleccionado == 'Alert') {
      this.updateTables;
    } else if (tabSeleccionado == 'Jobs') {
      this.updateSignatureDashboard();
    }
  }

  //metodo para establecer el parametro ON/OFF
  getParameter(statusSwitch: boolean): string {
    let parametro;
    if (statusSwitch) {
      parametro = 'OFF';
    } else {
      parametro = 'ON';
    }
    return parametro;
  }

  //cuando el usuario cambia el estado del Toggle
  onChangeToggle(datosToggle: DatosToggle, tabName: string) {
    if (tabName == 'Authentication') {
      this.techAdminStore
        .changeStatusAuthentication(datosToggle.nameAlert, this.getParameter(datosToggle.statusSwitch))
        .pipe(finalize(() => this.updateAuthDashboard()))
        .subscribe(
          (resp) => {},
          (error) => {
            if (error.statusText !== 'OK') {
              this.showDialogError(this.translateService.instant('error.pagina_403'));
              this.loadgraphic = false;
            }
          }
        );
    } else if (tabName == 'Signature') {
      this.techAdminStore
        .changeStatusSignature(datosToggle.nameAlert, this.getParameter(datosToggle.statusSwitch))
        .pipe(finalize(() => this.updateSignatureDashboard()))
        .subscribe(
          (resp) => {},
          (error: HttpErrorResponse) => {
            if (error.statusText !== 'OK') {
              this.showDialogError(this.translateService.instant('error.pagina_403'));
              this.loadgraphic = false;
            }
          }
        );
    } else if (tabName == 'Request') {
      this.techAdminStore
        .changeStatusRequest(datosToggle.nameAlert, this.getParameter(datosToggle.statusSwitch))
        .pipe(finalize(() => this.updateRequestDashboard()))
        .subscribe(
          (resp) => {},
          (error) => {
            if (error.statusText !== 'OK') {
              this.showDialogError(this.translateService.instant('error.pagina_403'));
              this.loadgraphic = false;
            }
          }
        );
    } else if (tabName == 'Administration') {
      this.techAdminStore
        .changeStatusAdministration(datosToggle.nameAlert, this.getParameter(datosToggle.statusSwitch))
        .pipe(finalize(() => this.updateAdminDashboard()))
        .subscribe(
          (resp) => {},
          (error) => {
            if (error.statusText !== 'OK') {
              this.showDialogError(this.translateService.instant('error.pagina_403'));
              this.loadgraphic = false;
            }
          }
        );
    } else if (tabName == 'Jobs') {
      this.techAdminStore
        .changeStatusJob(datosToggle.nameAlert, this.getParameter(datosToggle.statusSwitch))
        .pipe(finalize(() => this.updateJobDashboard()))
        .subscribe(
          (resp) => {},
          (error) => {
            if (error.statusText !== 'OK') {
              this.showDialogError(this.translateService.instant('error.pagina_403'));
              this.loadgraphic = false;
            }
          }
        );
    }
  }

  //Metodo compare para ordenar por defecto
  sortData(data: Alert[]) {
    data.sort((firstObject: Alert, secondObject: Alert) => (firstObject.name > secondObject.name ? 1 : -1));
  }

  //Metodo compare para ordenar por defecto jobs
  sortDataJobs(data: Job[]) {
    data.sort((firstObject: Job, secondObject: Job) => (firstObject.jobName > secondObject.jobName ? 1 : -1));
  }

  //Metodo quitar elemento de array
  removeElement(data: Alert[], nameObj: string) {
    let borrar = -1;
    data.forEach(function (item, index) {
      if (item.name == nameObj) {
        borrar = index;
      }
    });

    if (borrar > -1) {
      data.splice(borrar, 1);
    }
  }
}
